import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Modal, Spin } from 'antd';
import Cleave from 'cleave.js/react';
import { pushToDataLayer } from '../../utils';
import PreQualFunnelLayout from '../PreQualFunnelLayout';
import SectionHeader from '../components/SectionHeader/SectionHeader';
import FooterCard from '../components/FooterCard/FooterCard';
import { NavigationRow } from '../components/NavigationRow/NavigationRow';
import { usePrequal } from '../../stores/prequalStore';
import { stepFinished } from '../../prequalNav';
import AppFormItem from '../../loan/components/AppFormItem';
import styles from './SSNStep.module.scss';
import { completePrequalFunnelV2 } from '../../utils/prequalHelper';

const SSNStep = observer(() => {
  const prequalStore = usePrequal();
  const { prequal } = prequalStore;
  const [form] = Form.useForm();
  const [canContinue, setCanContinue] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const updateValues = async (values: any) => {
    prequalStore.setSSN(values.ssn);
    setSubmitting(true);
    await completePrequalFunnelV2();
    setSubmitting(false);
    stepFinished();
  };

  const checkSSN = (_changed: any, values: any) => {
    const { ssn } = values;
    setCanContinue(!!ssn && ssn.length === 4);
  };

  useEffect(() => {
    pushToDataLayer('pageview', {
      detailed_page_name: 'ssn',
      site_section: 'loan application',
    });
  }, []);

  const header = {
    title: 'About You',
    subtitle: 'One Last Step to Check Your Loan Options',
    content:
      'We need the last 4 digits of your SSN to securely verify your identity and match you with the best available offers.',
  };

  return (
    <PreQualFunnelLayout iconTexts={['', 'No spam from lenders', '']}>
      <Modal visible={submitting} footer={null} closable={false}>
        <p>Checking offers for you...</p>
        <Spin size="large" style={{ marginTop: '2rem', display: 'block' }} />
      </Modal>
      <SectionHeader header={header} />
      <Form form={form} initialValues={prequal} onFinish={updateValues} onValuesChange={checkSSN}>
        <div className={styles.ssnContainer}>
          <AppFormItem
            name="ssn"
            required
            hasFeedback={false}
            rules={[
              { required: true, message: 'Please enter your Social Security Number' },
              {
                validator: async (_, value) => {
                  if (value && value.length !== 4) {
                    throw new Error('Please enter a valid Social Security Number');
                  }
                },
              },
            ]}
          >
            <div className={styles.inputWrapper}>
              <label className={styles.labelText} htmlFor="ssn">
                Last 4 of SSN
              </label>
              <Cleave
                id="ssn"
                placeholder="Enter Last 4 Digits of SSN"
                options={{
                  blocks: [4],
                  numericOnly: true,
                }}
                className={styles.ssnInput}
              />
              <img
                src="/static/trident/shield-icon.svg"
                className={styles.shieldIcon}
                alt="shield-icon"
              />
            </div>
          </AppFormItem>
        </div>
        <NavigationRow canContinue={canContinue} form={form} />
      </Form>
      <FooterCard showFirstItem />
    </PreQualFunnelLayout>
  );
});

export default SSNStep;
